module.exports = __webpack_public_path__ + "static/img/icon-team-logo-default.3d30e226.png";